const GeneralActionTypes = {
	RESET_ALL_REDUCER_STATE_START: 'reset_all_reducer_state_start',

	IS_EDIT_DETAILS_START: 'is_edit_details_start',
	IS_OPEN_OFFCANVAS_START: 'is_open_offcanvas_start',

	/** ***************** GET COUNTRY LIST START *********************** */
	GET_COUNTRY_LIST_START: 'get_country_list_start',
	GET_COUNTRY_LIST_SUCCESS: 'get_country_list_success',
	GET_COUNTRY_LIST_FAILURE: 'get_country_list_failure',
	GET_COUNTRY_LIST_RESPONSE_RESET: 'get_country_list_response_reset',
	GET_COUNTRY_LIST_RESPONSE_CHANGED: 'get_country_list_response_changed',
	/** ***************** GET COUNTRY LIST END *********************** */

	/** ***************** GET STATE LIST START *********************** */
	GET_STATE_LIST_START: 'get_state_list_start',
	GET_STATE_LIST_SUCCESS: 'get_state_list_success',
	GET_STATE_LIST_FAILURE: 'get_state_list_failure',
	GET_STATE_LIST_RESPONSE_RESET: 'get_state_list_response_reset',
	GET_STATE_LIST_RESPONSE_CHANGED: 'get_state_list_response_changed',
	/** ***************** GET STATE LIST END *********************** */

	/** ***************** GET CITY LIST START *********************** */
	GET_CITY_LIST_START: 'get_city_list_start',
	GET_CITY_LIST_SUCCESS: 'get_city_list_success',
	GET_CITY_LIST_FAILURE: 'get_city_list_failure',
	GET_CITY_LIST_RESPONSE_RESET: 'get_city_list_response_reset',
	GET_CITY_LIST_RESPONSE_CHANGED: 'get_city_list_response_changed',
	/** ***************** GET CITY LIST END *********************** */

	/** ***************** GET PINCODE LIST START *********************** */
	GET_PINCODE_LIST_START: 'get_pincode_list_start',
	GET_PINCODE_LIST_SUCCESS: 'get_pincode_list_success',
	GET_PINCODE_LIST_FAILURE: 'get_pincode_list_failure',
	GET_PINCODE_LIST_RESPONSE_RESET: 'get_pincode_list_response_reset',
	GET_PINCODE_LIST_RESPONSE_CHANGED: 'get_pincode_list_response_changed',
	/** ***************** GET PINCODE LIST END *********************** */

	/** ***************** GET DISTRICT LIST START *********************** */
	GET_DISTRICT_LIST_START: 'get_district_list_start',
	GET_DISTRICT_LIST_SUCCESS: 'get_district_list_success',
	GET_DISTRICT_LIST_FAILURE: 'get_district_list_failure',
	GET_DISTRICT_LIST_RESPONSE_RESET: 'get_district_list_response_reset',
	GET_DISTRICT_LIST_RESPONSE_CHANGED: 'get_district_list_response_changed',
	/** ***************** GET DISTRICT LIST END *********************** */

	/** ***************** GET INDUSTRY LIST START *********************** */
	GET_INDUSTRY_LIST_START: 'get_industry_list_start',
	GET_INDUSTRY_LIST_SUCCESS: 'get_industry_list_success',
	GET_INDUSTRY_LIST_FAILURE: 'get_industry_list_failure',
	GET_INDUSTRY_LIST_RESPONSE_RESET_START: 'get_industry_list_response_reset_start',
	GET_INDUSTRY_LIST_RESPONSE_CHANGED: 'get_industry_list_response_changed',
	/** ***************** GET INDUSTRY LIST END *********************** */

	/** ***************** GET SUB INDUSTRY LIST START *********************** */
	GET_SUB_INDUSTRY_LIST_START: 'get_sub_industry_list_start',
	GET_SUB_INDUSTRY_LIST_SUCCESS: 'get_sub_industry_list_success',
	GET_SUB_INDUSTRY_LIST_FAILURE: 'get_sub_industry_list_failure',
	GET_SUB_INDUSTRY_LIST_RESPONSE_RESET_START: 'get_sub_industry_list_response_reset_start',
	GET_SUB_INDUSTRY_LIST_RESPONSE_CHANGED: 'get_sub_industry_list_response_changed',
	/** ***************** GET SUB INDUSTRY LIST END *********************** */

	/** ***************** FETCH ALL BRANCHES LIST START *********************** */
	FETCH_ALL_BRANCHES_START: 'fetch_all_branches_start',
	FETCH_ALL_BRANCHES_SUCCESS: 'fetch_all_branches_success',
	FETCH_ALL_BRANCHES_FAILURE: 'fetch_all_branches_failure',
	FETCH_ALL_BRANCHES_RESPONSE_RESET_START: 'fetch_all_branches_response_reset',
	FETCH_ALL_BRANCHES_RESPONSE_CHANGED: 'fetch_all_branches_response_changed',
	/** ***************** FETCH ALL BRANCHES LIST END *********************** */

	/** ***************** FETCH ALL PURPOSE OF LOAN LIST START *********************** */
	FETCH_ALL_PURPOSE_OF_LOAN_LIST_START: 'fetch_all_purpose_of_loan_list_start',
	FETCH_ALL_PURPOSE_OF_LOAN_LIST_SUCCESS: 'fetch_all_purpose_of_loan_list_success',
	FETCH_ALL_PURPOSE_OF_LOAN_LIST_FAILURE: 'fetch_all_purpose_of_loan_list_failure',
	FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET_START:
		'fetch_all_purpose_of_loan_list_response_reset',
	FETCH_ALL_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED:
		'fetch_all_purpose_of_loan_list_response_changed',
	/** ***************** FETCH ALL PURPOSE OF LOAN LIST END *********************** */

	/** ***************** FETCH ALL PURPOSE OF LOAN TYPE LIST START *********************** */
	FETCH_ALL_PURPOSE_OF_LOAN_TYPE_START: 'fetch_all_purpose_of_loan_type_start',
	FETCH_ALL_PURPOSE_OF_LOAN_TYPE_SUCCESS: 'fetch_all_purpose_of_loan_type_success',
	FETCH_ALL_PURPOSE_OF_LOAN_TYPE_FAILURE: 'fetch_all_purpose_of_loan_type_failure',
	FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_RESET_START:
		'fetch_all_purpose_of_loan_type_response_reset',
	FETCH_ALL_PURPOSE_OF_LOAN_TYPE_RESPONSE_CHANGED:
		'fetch_all_purpose_of_loan_type_response_changed',
	/** ***************** FETCH ALL PURPOSE OF LOAN TYPE LIST END *********************** */

	/** ***************** FETCH ALL BUSINESS LIST LIST START *********************** */
	FETCH_ALL_BUSINESS_LIST_START: 'fetch_all_business_list_start',
	FETCH_ALL_BUSINESS_LIST_SUCCESS: 'fetch_all_business_list_success',
	FETCH_ALL_BUSINESS_LIST_FAILURE: 'fetch_all_business_list_failure',
	FETCH_ALL_BUSINESS_LIST_RESPONSE_RESET_START: 'fetch_all_business_list_response_reset',
	FETCH_ALL_BUSINESS_LIST_RESPONSE_CHANGED: 'fetch_all_business_list_response_changed',
	/** ***************** FETCH ALL BUSINESS LIST LIST END *********************** */

	/** ***************** FETCH ALL PRODUCT TYPE LIST LIST START *********************** */
	FETCH_ALL_PRODUCT_TYPE_START: 'fetch_all_product_type_start',
	FETCH_ALL_PRODUCT_TYPE_SUCCESS: 'fetch_all_product_type_success',
	FETCH_ALL_PRODUCT_TYPE_FAILURE: 'fetch_all_product_type_failure',
	FETCH_ALL_PRODUCT_TYPE_RESPONSE_RESET: 'fetch_all_product_type_response_reset',
	FETCH_ALL_PRODUCT_TYPE_RESPONSE_CHANGED: 'fetch_all_product_type_response_changed',
	/** ***************** FETCH ALL PRODUCT TYPE LIST LIST END *********************** */

	/** ***************** FETCH ALL PRODUCT LIST START *********************** */
	FETCH_ALL_PRODUCT_START: 'fetch_all_product_start',
	FETCH_ALL_PRODUCT_SUCCESS: 'fetch_all_product_success',
	FETCH_ALL_PRODUCT_FAILURE: 'fetch_all_product_failure',
	FETCH_ALL_PRODUCT_RESPONSE_RESET: 'fetch_all_product_response_reset',
	FETCH_ALL_PRODUCT_RESPONSE_CHANGED: 'fetch_all_product_response_changed',
	/** ***************** FETCH ALL PRODUCT LIST LIST END *********************** */

	/** ***************** FETCH ALL BRANCH OFFICER LIST START *********************** */
	FETCH_ALL_BRANCH_OFFICER_START: 'fetch_all_branch_officer_start',
	FETCH_ALL_BRANCH_OFFICER_SUCCESS: 'fetch_all_branch_officer_success',
	FETCH_ALL_BRANCH_OFFICER_FAILURE: 'fetch_all_branch_officer_failure',
	FETCH_ALL_BRANCH_OFFICER_RESPONSE_RESET_START: 'fetch_all_branch_officer_response_reset_start',
	FETCH_ALL_BRANCH_OFFICER_RESPONSE_CHANGED: 'fetch_all_branch_officer_response_changed',
	/** ***************** FETCH ALL BRANCH OFFICER LIST END *********************** */

	/** ***************** FETCH ALL CENTERS LIST START *********************** */
	FETCH_ALL_CENTERS_START: 'fetch_all_centers_start',
	FETCH_ALL_CENTERS_SUCCESS: 'fetch_all_centers_success',
	FETCH_ALL_CENTERS_FAILURE: 'fetch_all_centers_failure',
	FETCH_ALL_CENTERS_RESPONSE_RESET_START: 'fetch_all_centers_response_reset',
	FETCH_ALL_CENTERS_RESPONSE_CHANGED: 'fetch_all_centers_response_changed',
	/** ***************** FETCH ALL CENTERS LIST END *********************** */

	/** ***************** FETCH ALL CENTERS GROUPS LIST START *********************** */
	FETCH_CENTER_GROUPS_START: 'fetch_center_groups_start',
	FETCH_CENTER_GROUPS_SUCCESS: 'fetch_center_groups_success',
	FETCH_CENTER_GROUPS_FAILURE: 'fetch_center_groups_failure',
	FETCH_CENTER_GROUPS_RESPONSE_RESET_START: 'fetch_center_groups_response_reset',
	FETCH_CENTER_GROUPS_RESPONSE_CHANGED: 'fetch_center_groups_response_changed',
	/** ***************** FETCH ALL CENTERS GROUPS LIST END *********************** */

	/** ***************** FETCH ALL GROUP MEMBERS LIST START *********************** */
	FETCH_GROUP_MEMBERS_START: 'fetch_group_members_start',
	FETCH_GROUP_MEMBERS_SUCCESS: 'fetch_group_members_success',
	FETCH_GROUP_MEMBERS_FAILURE: 'fetch_group_members_failure',
	FETCH_GROUP_MEMBERS_RESPONSE_RESET_START: 'fetch_group_members_response_reset',
	FETCH_GROUP_MEMBERS_RESPONSE_CHANGED: 'fetch_group_members_response_changed',
	/** ***************** FETCH ALL GROUP MEMBERS LIST END *********************** */

	/** ***************** FETCH ALL INVESTOR LIST START *********************** */
	FETCH_ALL_INVESTOR_LIST_START: 'fetch_all_investor_list_start',
	FETCH_ALL_INVESTOR_LIST_SUCCESS: 'fetch_all_investor_list_success',
	FETCH_ALL_INVESTOR_LIST_FAILURE: 'fetch_all_center_failure',
	FETCH_ALL_INVESTOR_LIST_RESPONSE_RESET_START: 'fetch_all_investor_list_response_reset',
	FETCH_ALL_INVESTOR_LIST_RESPONSE_CHANGED: 'fetch_all_investor_list_response_changed',
	/** ***************** FETCH ALL INVESTOR LIST END *********************** */

	/** ***************** FETCH ALL GROUP LIST START *********************** */
	FETCH_ALL_GROUP_LIST_START: 'fetch_All_Group_List_Start',
	FETCH_ALL_GROUP_LIST_SUCCESS: 'fetch_All_Group_List_Success',
	FETCH_ALL_GROUP_LIST_FAILURE: 'fetch_All_Group_List_Failure',
	FETCH_ALL_GROUP_LIST_RESPONSE_RESET: 'fetch_All_Group_List_Response_Reset',
	FETCH_ALL_GROUP_LIST_RESPONSE_CHANGED: 'fetch_All_Group_List_Response_Changed',
	/** ***************** FETCH ALL GROUP LIST END *********************** */

	/** ***************** FETCH BRANCH ACCOUNT LIST START *********************** */
	FETCH_BRANCH_ACCOUNT_LIST_START: 'FETCH_BRANCH_ACCOUNT_LIST_START',
	FETCH_BRANCH_ACCOUNT_LIST_SUCCESS: 'FETCH_BRANCH_ACCOUNT_LIST_SUCCESS',
	FETCH_BRANCH_ACCOUNT_LIST_FAILURE: 'FETCH_BRANCH_ACCOUNT_LIST_FAILURE',
	FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_RESET_START:
		'FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_RESET_START',
	FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_CHANGED: 'FETCH_BRANCH_ACCOUNT_LIST_RESPONSE_CHANGED',
	/** ***************** FETCH BRANCH ACCOUNT LIST END *********************** */

	/** ***************** FETCH LOAN INDEX BASED GROUP LIST START *********************** */
	FETCH_LOAN_INDEX_BASED_GROUP_START: 'FETCH_LOAN_INDEX_BASED_GROUP_START',
	FETCH_LOAN_INDEX_BASED_GROUP_SUCCESS: 'FETCH_LOAN_INDEX_BASED_GROUP_SUCCESS',
	FETCH_LOAN_INDEX_BASED_GROUP_FAILURE: 'FETCH_LOAN_INDEX_BASED_GROUP_FAILURE',
	FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_RESET_START:
		'FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_RESET_START',
	FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_CHANGED: 'FETCH_LOAN_INDEX_BASED_GROUP_RESPONSE_CHANGED',
	/** ***************** FETCH LOAN INDEX BASED GROUP LIST END *********************** */

	/** ***************** FETCH SEARCH LOAN INDEX LIST START *********************** */
	FETCH_SEARCH_LOAN_INDEX_START: 'FETCH_SEARCH_LOAN_INDEX_START',
	FETCH_SEARCH_LOAN_INDEX_SUCCESS: 'FETCH_SEARCH_LOAN_INDEX_SUCCESS',
	FETCH_SEARCH_LOAN_INDEX_FAILURE: 'FETCH_SEARCH_LOAN_INDEX_FAILURE',
	FETCH_SEARCH_LOAN_INDEX_RESPONSE_RESET_START: 'FETCH_SEARCH_LOAN_INDEX_RESPONSE_RESET_START',
	FETCH_SEARCH_LOAN_INDEX_RESPONSE_CHANGED: 'FETCH_SEARCH_LOAN_INDEX_RESPONSE_CHANGED',
	/** ***************** FETCH SEARCH LOAN INDEX LIST END *********************** */

	/** ***************** FETCH VERSION START *********************** */
	FETCH_VERSION_START: 'fetch_Version_Start',
	FETCH_VERSION_SUCCESS: 'fetch_Version_Success',
	FETCH_VERSION_FAILURE: 'fetch_Version_Failure',
	FETCH_VERSION_RESPONSE_RESET: 'fetch_Version_Response_Reset',
	FETCH_VERSION_RESPONSE_CHANGED: 'fetch_Version_Response_Changed',
	/** ***************** FETCH VERSION END *********************** */

	/** ***************** UPDATE VERSION START *********************** */
	UPDATE_VERSION_START: 'update_Version_Start',
	UPDATE_VERSION_SUCCESS: 'update_Version_Success',
	UPDATE_VERSION_FAILURE: 'update_Version_Failure',
	UPDATE_VERSION_RESPONSE_RESET: 'update_Version_Response_Reset',
	UPDATE_VERSION_RESPONSE_CHANGED: 'update_Version_Response_Changed',
	/** ***************** UPDATE VERSION END *********************** */

	/** ***************** FETCH PINCODE DETAILS START *********************** */
	FETCH_PINCODE_DETAILS_START: 'fetch_pincode_details_Start',
	FETCH_PINCODE_DETAILS_SUCCESS: 'fetch_pincode_details_Success',
	FETCH_PINCODE_DETAILS_FAILURE: 'fetch_pincode_details_Failure',
	FETCH_PINCODE_DETAILS_RESPONSE_RESET: 'fetch_pincode_details_Response_Reset',
	FETCH_PINCODE_DETAILS_RESPONSE_CHANGED: 'fetch_pincode_details_Response_Changed',
	/** ***************** FETCH PINCODE DETAILS END *********************** */

	/** ***************** GENERIC PINCODE DETAILS START *********************** */
	GENERIC_PINCODE_DETAILS_START: 'generic_pincode_details_Start',
	GENERIC_PINCODE_DETAILS_SUCCESS: 'generic_pincode_details_Success',
	GENERIC_PINCODE_DETAILS_FAILURE: 'generic_pincode_details_Failure',
	GENERIC_PINCODE_DETAILS_RESPONSE_RESET: 'generic_pincode_details_Response_Reset',
	GENERIC_PINCODE_DETAILS_RESPONSE_CHANGED: 'generic_pincode_details_Response_Changed',
	/** ***************** GENERIC PINCODE DETAILS END *********************** */

	/** ***************** GET LOCATION LIST BASED LEVEL START *********************** */
	GET_LOCATION_LIST_BASED_LEVEL_START: 'get_location_list_based_level_start',
	GET_LOCATION_LIST_BASED_LEVEL_SUCCESS: 'get_location_list_based_level_success',
	GET_LOCATION_LIST_BASED_LEVEL_FAILURE: 'get_location_list_based_level_failure',
	GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_RESET: 'get_location_list_based_level_response_reset',
	GET_LOCATION_LIST_BASED_LEVEL_RESPONSE_CHANGED:
		'get_location_list_based_level_response_changed',
	/** ***************** GET LOCATION LIST BASED LEVEL END *********************** */

	/** ***************** CHECK GOOGLE AUTHENTICATION START *********************** */
	CHECK_GOOGLE_AUTHENTICATION_START: 'check_google_authentication_Start',
	CHECK_GOOGLE_AUTHENTICATION_SUCCESS: 'check_google_authentication_Success',
	CHECK_GOOGLE_AUTHENTICATION_FAILURE: 'check_google_authentication_Failure',
	CHECK_GOOGLE_AUTHENTICATION_RESPONSE_RESET: 'check_google_authentication_Response_Reset',
	CHECK_GOOGLE_AUTHENTICATION_RESPONSE_CHANGED: 'check_google_authentication_Response_Changed',
	/** ***************** CHECK GOOGLE AUTHENTICATION END *********************** */

	/** ***************** GET PURPOSE OF LOAN PROPOSAL LIST START *********************** */
	GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_START: 'get_purpose_of_loan_proposal_list_start',
	GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_SUCCESS: 'get_purpose_of_loan_proposal_list_success',
	GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_FAILURE: 'get_purpose_of_loan_proposal_list_failure',
	GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_RESET:
		'get_purpose_of_loan_proposal_list_response_reset',
	GET_PURPOSE_OF_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED:
		'get_purpose_of_loan_proposal_list_response_changed',
	/** ***************** GET PURPOSE OF LOAN PROPOSAL LIST END *********************** */

	/** ***************** GET OFFICER BASED ON LEVEL LIST START *********************** */
	GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_START:
		'get_officer_based_on_level_list_proposal_start',
	GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_SUCCESS:
		'get_officer_based_on_level_list_proposal_success',
	GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_FAILURE:
		'get_officer_based_on_level_list_proposal_failure',
	GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_RESET:
		'get_officer_based_on_level_list_proposal_response_reset',
	GET_OFFICER_BASED_ON_LEVEL_LIST_PROPOSAL_RESPONSE_CHANGED:
		'get_officer_based_on_level_list_proposal_response_changed',
	/** ***************** GET OFFICER BASED ON LEVEL LIST END *********************** */

	/** ***************** GET THRIFT LIST PROPOSAL START *********************** */
	GET_THRIFT_LIST_PROPOSAL_START: 'get_thrift_list_proposal_start',
	GET_THRIFT_LIST_PROPOSAL_SUCCESS: 'get_thrift_list_proposal_success',
	GET_THRIFT_LIST_PROPOSAL_FAILURE: 'get_thrift_list_proposal_failure',
	GET_THRIFT_LIST_PROPOSAL_RESPONSE_RESET: 'get_thrift_list_proposal_response_reset',
	GET_THRIFT_LIST_PROPOSAL_RESPONSE_CHANGED: 'get_thrift_list_proposal_response_changed',
	/** ***************** GET THRIFT LIST PROPOSAL END *********************** */

	/** ***************** GET THRIFT DETAILS START *********************** */
	GET_THRIFT_DETAILS_START: 'get_thrift_details_start',
	GET_THRIFT_DETAILS_SUCCESS: 'get_thrift_details_success',
	GET_THRIFT_DETAILS_FAILURE: 'get_thrift_details_failure',
	GET_THRIFT_DETAILS_RESPONSE_RESET: 'get_thrift_details_response_reset',
	GET_THRIFT_DETAILS_RESPONSE_CHANGED: 'get_thrift_details_response_changed',
	/** ***************** GET THRIFT DETAILS END *********************** */

	/** ***************** GET THRIFT TWO DETAILS START *********************** */
	GET_THRIFT_TWO_DETAILS_START: 'get_thrift_two_details_start',
	GET_THRIFT_TWO_DETAILS_SUCCESS: 'get_thrift_two_details_success',
	GET_THRIFT_TWO_DETAILS_FAILURE: 'get_thrift_two_details_failure',
	GET_THRIFT_TWO_DETAILS_RESPONSE_RESET: 'get_thrift_two_details_response_reset',
	GET_THRIFT_TWO_DETAILS_RESPONSE_CHANGED: 'get_thrift_two_details_response_changed',
	/** ***************** GET THRIFT TWO DETAILS END *********************** */

	/** ***************** GET NON APPROVE MEMBERS DETAILS START *********************** */
	GET_NON_APPROVE_MEMBERS_DETAILS_START: 'get_non_approve_members_details_start',
	GET_NON_APPROVE_MEMBERS_DETAILS_SUCCESS: 'get_non_approve_members_details_success',
	GET_NON_APPROVE_MEMBERS_DETAILS_FAILURE: 'get_non_approve_members_details_failure',
	GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_RESET:
		'get_non_approve_members_details_response_reset',
	GET_NON_APPROVE_MEMBERS_DETAILS_RESPONSE_CHANGED:
		'get_non_approve_members_details_response_changed',
	/** ***************** GET NON APPROVE MEMBERS DETAILS END *********************** */

	/** ***************** GET TODAY GOLD PRICE START *********************** */
	GET_TODAY_GOLD_PRICE_START: 'get_today_gold_price_start',
	GET_TODAY_GOLD_PRICE_SUCCESS: 'get_today_gold_price_success',
	GET_TODAY_GOLD_PRICE_FAILURE: 'get_today_gold_price_failure',
	GET_TODAY_GOLD_PRICE_RESPONSE_RESET: 'get_today_gold_price_response_reset',
	GET_TODAY_GOLD_PRICE_RESPONSE_CHANGED: 'get_today_gold_price_response_changed',
	/** ***************** GET TODAY GOLD PRICE END *********************** */

	/** ***************** GET UPDATE GOLD PRICE START *********************** */
	UPDATE_TODAY_GOLD_PRICE_START: 'update_today_gold_price_start',
	UPDATE_TODAY_GOLD_PRICE_SUCCESS: 'update_today_gold_price_success',
	UPDATE_TODAY_GOLD_PRICE_FAILURE: 'update_today_gold_price_failure',
	UPDATE_TODAY_GOLD_PRICE_RESPONSE_RESET: 'update_today_gold_price_response_reset',
	UPDATE_TODAY_GOLD_PRICE_RESPONSE_CHANGED: 'update_today_gold_price_response_changed',
	/** ***************** GET UPDATE GOLD PRICE END *********************** */

	/** ***************** GET BRANCHES FOR STATE START *********************** */
	GET_STATEWISW_BRANCHES_START: 'get_statewise_branches_start',
	GET_STATEWISW_BRANCHES_SUCCESS: 'get_statewise_branches_success',
	GET_STATEWISW_BRANCHES_FAILURE: 'get_statewise_branches_failure',
	GET_STATEWISW_BRANCHES_RESPONSE_RESET: 'get_statewise_branches_response_reset',
	GET_STATEWISW_BRANCHES_RESPONSE_CHANGED: 'get_statewise_branches_response_changed',
	/** ***************** GET BRANCHES FOR STATE START *********************** */

	GROUPMEMBERLIST: 'GROUPMEMBERLIST',
};

export default GeneralActionTypes;
